// extracted by mini-css-extract-plugin
export default {"popover":"PaymentHistory_popover__ivl-7"};